<div class="general_colum">
  <div class="row">
    <div class="col-xxl-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
      <p class="text_header">Licencia para prestación de servicios en Seguridad y Salud en el trabajo</p>
      <p class="mt-3 text-justify">
        Solicitar la expedición , renovación o modificación de la licencia para prestar servicios en Seguridad y Salud en el <br />
        Trabajo como persona natural o jurídica, pública o privada
      </p>
    </div>
  </div>
  <hr style="width: 67%;" />
  <div class="row">
    <div class="col-6">
      <p>ID Trámite</p>
    </div>
    <div class="col-6">
      <p>{{tramiteActual.filedNumber}}</p>
    </div>
  </div>
  <hr style="width: 67%; margin-top: -10px;" />
  <div class="row">
    <div class="col-6">
      <p>Tipo Trámite</p>
    </div>
    <div class="col-6">
      <p>{{tramiteActual.process}}</p>
    </div>
  </div>
  <hr style="width: 67%; margin-top: -10px;" />
  <div class="row">
    <div class="col-6">
      <p>Estado</p>
    </div>
    <div class="col-6">
      <p>{{tramiteActual.status}}</p>
    </div>
  </div>
  <hr style="width: 67%; margin-top: -10px;" />
  <div class="row">
    <div class="col-6">
      <p>Observación</p>
    </div>
    <div class="col-6">
      <p>{{trackingTramiteActual.observation}}</p>
    </div>
  </div>
  <hr style="width: 67%; margin-top: -10px;" />

  <form role="form" [formGroup]="solicitudForm">

    <div class="accordion-govco" id="accordionExampleTwo">

      <div class="item-accordion-govco" *ngIf="isModification==true">
        <h2 class="accordion-header" id="accordionIconoPanels-exampleSix">
          <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseSix"
                  aria-expanded="false" aria-controls="accordionIconoPanels-collapseSix">
            <span class="text-button-accordion-govco">
              <h4 class="h4-tipografia-govco title-1">Seleccione Motivo Modificacion</h4>
            </span>
          </button>
        </h2>
        <div id="accordionIconoPanels-collapseSix" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleSix"
             data-bs-parent="#accordionExampleTwo">
          <div class="body-accordion-govco">
            <app-modification [isPersonaJuridica]="isLegalPerson"></app-modification>
          </div>
        </div>
      </div>

      <div class="item-accordion-govco" *ngIf="isRenewal==true">
        <h2 class="accordion-header" id="accordionIconoPanels-exampleFive">
          <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseFive"
                  aria-expanded="false" aria-controls="accordionIconoPanels-collapseFive">
            <span class="text-button-accordion-govco title-1">
              <h4 class="h4-tipografia-govco title-1">Datos adicionales renovación</h4>
            </span>
          </button>
        </h2>
        <div id="accordionIconoPanels-collapseFive" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleFive"
             data-bs-parent="#accordionExampleTwo">
          <div class="body-accordion-govco">
            <app-renewal></app-renewal>
          </div>
        </div>
      </div>

      <div class="item-accordion-govco" *ngIf="isLegalPerson == false">
        <h2 class="accordion-header" id="accordionIconoPanels-exampleTwo">
          <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseTwo"
                  aria-expanded="false" aria-controls="accordionIconoPanels-collapseTwo">
            <span class="text-button-accordion-govco title-1">
              <h4 class="h4-tipografia-govco title-1">Datos Laborales</h4>
            </span>
          </button>
        </h2>
        <div id="accordionIconoPanels-collapseTwo" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleTwo"
             data-bs-parent="#accordionExampleTwo">
          <div class="body-accordion-govco">
            <app-labor-data></app-labor-data>
          </div>
        </div>
      </div>

      <div class="item-accordion-govco">
        <h2 class="accordion-header" id="accordionIconoPanels-exampleThree">
          <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse"
                  data-bs-target="#accordionIconoPanels-collapseThree" aria-expanded="false" aria-controls="accordionIconoPanels-collapseThree">
            <span class="text-button-accordion-govco title-1">
              <h4 class="h4-tipografia-govco title-1">Tipos de Servicio a Prestar</h4>
            </span>
          </button>
        </h2>
        <div id="accordionIconoPanels-collapseThree" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleThree"
             data-bs-parent="#accordionExampleTwo">
          <div class="body-accordion-govco">
            <app-type-service-provide></app-type-service-provide>
          </div>
        </div>
      </div>

      <div class="item-accordion-govco">
        <h2 class="accordion-header" id="accordionIconoPanels-exampleFour">
          <button class="button-accordion-govco collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#accordionIconoPanels-collapseFour"
                  aria-expanded="false" aria-controls="accordionIconoPanels-collapseFour">
            <span class="text-button-accordion-govco title-1">
              <h4 class="h4-tipografia-govco title-1">Documentos Adjuntos</h4>
            </span>
          </button>
        </h2>
        <div id="accordionIconoPanels-collapseFour" class="accordion-collapse collapse" aria-labelledby="accordionIconoPanels-exampleFour"
             data-bs-parent="#accordionExampleTwo">
          <div class="body-accordion-govco">
            <app-attachments [isPersonaJuridica]="isLegalPerson"></app-attachments>
          </div>
        </div>
      </div>

    </div>
    <div class="col-12" style="margin: 5% 0 5% 0; text-align: right">
      <button type="button" class="btn-govco fill-btn-govco" (click)="saveValidation()" [disabled]="sending">Guardar</button>
    </div>
  </form>

</div>